document.addEventListener('DOMContentLoaded', function() {
    const btnTriggerOpen = document.querySelector('.made-to-order--btn');
    const btnTriggerClose = document.querySelector('.made-to-order--close-btn');
    const content = document.querySelector('.made-to-order--content');
    const htmlElement = document.querySelector('html');

    const handleToggleOpenContent = (contentElement) => {
        contentElement?.classList.toggle('is-open');
        htmlElement?.classList.toggle('no-scroll');
    }

    btnTriggerOpen?.addEventListener('click', () => handleToggleOpenContent(content));
    btnTriggerClose?.addEventListener('click', () => handleToggleOpenContent(content));

});